import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private httpSvc: HttpService) { }

  createPayment(payload: any) {
    return this.httpSvc.post(`/payments/order`, payload);
  }
  createPaymentUpagos(payload: any) {
    return this.httpSvc.post(`/payments/upagos/order`, payload);
  }

  createPaymentKhipu(payload: any) {
    return this.httpSvc.post(`/payments/khipu-pay`, payload);
  }

  getPendingOrderKhipu(id: any) {
    return this.httpSvc.get(`/company/payOrder/${id}`);
  }

  resultPayment(token: any) {
    return this.httpSvc.get(`/payments/statusToken/${token}`);
  }

  payStatus(id: any) {
    return this.httpSvc.get(`/payments/status/${id}`);
  }

  resultPaymentUpagos(token: any) {
    return this.httpSvc.get(`/payments/upagos/status-token/${token}`);
  }

  resultPaymentKhipu(token: any) {
    return this.httpSvc.get(`/payments/khipu-status-pay/${token}`);
  }

  payCredit(id: string) {
    return this.httpSvc.post(`/payments/upagos/postpay/${id}`);
  }

  getMyLastOrderPending() {
    return this.httpSvc.get(`/orders/lastPending`);
  }

  createPaymentTransBank(payload: any) {
    return this.httpSvc.post(`/payments/tbk-pay`, payload);
  }

  getPendingOrderTransBank(id: any) {
    return this.httpSvc.get(`/company/payOrderTbk/${id}`);
  }

  resultPaymentTransBank(token: any) {
    return this.httpSvc.get(`/payments/tbk-status-pay/${token}`);
  }

  payStatusTransBank(id: any) {
    return this.httpSvc.get(`/payments/tbk-status-pay-recharge/${id}`);
  }

  createPaymentOrders(payload: any) {
    return this.httpSvc.post(`/company/payOrders`, payload);
  }

  paymentsStatusKhipu(id: any) {
    return this.httpSvc.get(`/payments/khipu-status-payments/${id}`);
  }
  paymentsStatusTBK(id: any) {
    return this.httpSvc.get(`/payments/tbk-status-payments/${id}`);
  }

}
